import { useToast } from '@chakra-ui/react';
import { useCallback } from 'react';

const useToastNotification = () => {
  const toast = useToast();

  const showToast = useCallback(
    ({
      title,
      description,
      status,
      duration = 5000,
      isClosable = true,
    }: {
      title: string;
      description: string;
      status: 'success' | 'error' | 'warning' | 'info';
      duration?: number;
      isClosable?: boolean;
    }) => {
      toast({
        title,
        description,
        status,
        duration,
        isClosable,
      });
    },
    [toast],
  );

  return showToast;
};

export default useToastNotification;
